import React, { useState } from 'react';
import { Container, Form, Button, Alert, Spinner } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { AiOutlineLock, AiOutlineMail } from 'react-icons/ai';
import axios from '../utils/api';
import Particle from '../components/Particle';
import './AdminDashboard.css';

function AdminLogin() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      const response = await axios.post('/auth/login', { email, password });
      
      if (response.data.success) {
        localStorage.setItem('adminToken', response.data.token);
        navigate('/admin');
      } else {
        setError(response.data.error || 'Login failed');
      }
    } catch (err) {
      setError(
        err.response?.data?.error || 
        'Login failed. Please check your credentials.'
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ minHeight: '100vh', position: 'relative' }}>
      <Particle />
      <Container 
        className="d-flex justify-content-center align-items-center" 
        style={{ 
          minHeight: '100vh',
          position: 'relative',
          zIndex: 1
        }}
      >
        <div style={{ 
          width: '100%', 
          maxWidth: '450px',
          backgroundColor: 'white',
          padding: '3rem',
          borderRadius: '20px',
          boxShadow: '0 20px 60px rgba(0, 0, 0, 0.3)'
        }}>
          <div className="text-center mb-4">
            <div style={{ 
              width: '80px', 
              height: '80px', 
              background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
              borderRadius: '50%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              margin: '0 auto 1.5rem',
              boxShadow: '0 10px 30px rgba(102, 126, 234, 0.4)'
            }}>
              <AiOutlineLock size={40} color="white" />
            </div>
            <h2 style={{ 
              color: '#333', 
              fontWeight: '700',
              marginBottom: '0.5rem'
            }}>
              Admin Login
            </h2>
            <p style={{ color: '#666', margin: 0 }}>Access your portfolio dashboard</p>
          </div>
          
          {error && (
            <Alert variant="danger" className="alert-admin mb-3">
              {error}
            </Alert>
          )}

          <Form onSubmit={handleSubmit} className="admin-form">
            <Form.Group className="mb-3">
              <Form.Label>
                <AiOutlineMail style={{ marginRight: '0.5rem' }} />
                Email
              </Form.Label>
              <Form.Control
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                disabled={loading}
                placeholder="admin@example.com"
              />
            </Form.Group>

            <Form.Group className="mb-4">
              <Form.Label>
                <AiOutlineLock style={{ marginRight: '0.5rem' }} />
                Password
              </Form.Label>
              <Form.Control
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                disabled={loading}
                placeholder="Enter password"
              />
            </Form.Group>

            <Button 
              className="btn-primary-admin w-100"
              type="submit" 
              disabled={loading}
              style={{ padding: '0.875rem', fontSize: '1.1rem', fontWeight: '600' }}
            >
              {loading ? (
                <>
                  <Spinner animation="border" size="sm" className="me-2" />
                  Logging in...
                </>
              ) : (
                '🔐 Login'
              )}
            </Button>
          </Form>
        </div>
      </Container>
    </div>
  );
}

export default AdminLogin;

